module.exports = __webpack_public_path__ + "img/image132.58dd5ea7.jpg";